
(function () {
  var SPECS = [
    'shape-info','color-info','carat-info','clarity-info','cut-info',
    'certificate-type-info','polish-info','symmetry-info','fluorescence-info',
    'table-info','depth-info','measurements-info','l-w-ratio-info',
    'certificate-number','lab-name'
  ];
  var LABEL_MAP = {
    'shape':'shape-info','carat':'carat-info','color':'color-info',
    'clarity':'clarity-info','cut':'cut-info','polish':'polish-info',
    'symmetry':'symmetry-info','fluorescence':'fluorescence-info',
    'table':'table-info','depth':'depth-info',
    'measurement':'measurements-info','measurements':'measurements-info',
    'l/w ratio':'l-w-ratio-info','l/w':'l-w-ratio-info',
    'certificate':'certificate-type-info',
    'certificate number':'certificate-number','lab':'lab-name'
  };

  function heroVal(cls) {
    var src = document.querySelector('.diamond-product-template .diamond-short-information .' + cls)
           || document.querySelector('.diamond-product-template .diamond-info-wrapper .' + cls);
    return src ? (src.textContent || '').trim() : '';
  }
  function syncAccordion() {
    var acc = document.querySelector('.diamond-product-template .pair-first-diamond');
    if (!acc) return;
    SPECS.forEach(function (cls) {
      var v = heroVal(cls);
      var dst = acc.querySelector('.' + cls);
      if (!v || !dst) return;
      if ((dst.textContent || '').trim() !== v) dst.textContent = v;
    });
  }
  function syncStoneSpec() {
    var rows = document.querySelectorAll('.sp-stone-spec .sp-stone-spec__row');
    rows.forEach(function (row) {
      var labEl = row.querySelector('.sp-stone-spec__label');
      var valEl = row.querySelector('.sp-stone-spec__value');
      if (!labEl || !valEl) return;
      var key = (labEl.textContent || '').trim().toLowerCase();
      var cls = LABEL_MAP[key];
      if (!cls) return;
      var v = heroVal(cls);
      if (!v) return;
      if ((valEl.textContent || '').trim() !== v) valEl.textContent = v;
    });
  }
  function syncPrice() {
    var hero = document.querySelector('.diamond-product-template > .grid .product-single__price .price__on-sale');
    var sticky = document.querySelector('.diamond-product-template .sticky-button-price-wrapper .price__on-sale');
    if (!hero || !sticky) return;
    var v = (hero.textContent || '').trim();
    if (v && (sticky.textContent || '').trim() !== v) sticky.textContent = v;
  }

  function installIframeGates() {
    if (window.innerWidth > 768) return;
    var iframes = document.querySelectorAll('.diamond-product-template iframe');
    iframes.forEach(function (iframe) {
      if (iframe.dataset.spGated === '1') return;
      iframe.dataset.spGated = '1';
      var parent = iframe.parentElement;
      if (!parent) return;
      if (!parent.classList.contains('sp-iframe-wrap')) parent.classList.add('sp-iframe-wrap');
      if (parent.querySelector('.sp-360-pill')) return;

      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'sp-360-pill';
      pill.textContent = 'Tap to rotate 360°';
      pill.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasOn = parent.classList.contains('sp-360-on');
        var on = parent.classList.toggle('sp-360-on');
        pill.textContent = on ? 'Tap to unlock scroll' : 'Tap to rotate 360°';
        /* v12: when toggling OFF, reload the iframe so the video resets to its
           original auto-spin state. */
        if (wasOn && !on) {
          try {
            var src = iframe.src;
            iframe.src = 'about:blank';
            setTimeout(function () { iframe.src = src; }, 30);
          } catch (err) {}
        }
      });
      parent.appendChild(pill);
    });
  }

  function run() {
    try { syncAccordion(); } catch (e) {}
    try { syncStoneSpec(); } catch (e) {}
    try { syncPrice();     } catch (e) {}
    try { installIframeGates(); } catch (e) {}
  }

  function boot() {
    run();
    [300, 700, 1200, 2200, 3500, 5500, 8000].forEach(function (t) { setTimeout(run, t); });
    if ('MutationObserver' in window) {
      var main = document.getElementById('mainproduct') || document.querySelector('.diamond-product-template');
      if (main) {
        new MutationObserver(run).observe(main, {
          childList: true, subtree: true, characterData: true
        });
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
